import * as tabs from './tabs';
import { default as useTabs } from './useTabs';
export { tabs, useTabs };
